import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
  headline: {
    type: String,
    default: ''
  },
  text: {
    type: String,
    default: ''
  },
  concerned: {
    type: Object,
    default: () => ({})
  },
  actions: {
    type: Object,
    default: () => ({})
  },
  initialDisplayState: {
    type: Boolean,
    default: false
  }
},
  emits: ['modal'],
  setup(__props, { emit }) {

const props = __props;





const display = computed({
  get() {
    return props.initialDisplayState;
  },

  set(payload) {
    emit('modal', payload);
  }
});


return { __sfc: true,props, emit, display }
}

})